import { useEffect } from "react";

/**
 * Preload critical routes for faster navigation
 */
export const useRoutePreload = () => {
  useEffect(() => {
    const preloadRoutes = () => {
      const criticalRoutes = [
        () => import("@/pages/exeibit/Auth"),
      ];

      const adminRoutes = [
        () => import("@/pages/exeibit/Admin"),
        () => import("@/pages/hq/OperatorHQ"),
      ];

      let delay = 3000; // Start after 3s to avoid competing with initial render
      const preloadWithDelay = (importFn: () => Promise<unknown>, ms: number) => {
        setTimeout(() => {
          importFn().catch(() => {});
        }, ms);
      };

      criticalRoutes.forEach((route) => {
        preloadWithDelay(route, delay);
        delay += 200;
      });

      adminRoutes.forEach((route) => {
        preloadWithDelay(route, delay + 2000);
        delay += 200;
      });
    };

    if ("requestIdleCallback" in window) {
      (window as Window & { requestIdleCallback: (cb: () => void) => void }).requestIdleCallback(preloadRoutes);
    } else {
      setTimeout(preloadRoutes, 2000);
    }
  }, []);
};

/**
 * Preload a specific route on hover/focus
 */
export const preloadRoute = (routeImport: () => Promise<unknown>) => {
  routeImport().catch(() => {});
};

/**
 * Critical routes map for Link components
 */
export const routePreloaders = {
  auth: () => import("@/pages/exeibit/Auth"),
  admin: () => import("@/pages/exeibit/Admin"),
};
